<template>
    <section class="dataisian">
        <div class="logo">
            <img src="@/assets/logo single.png" alt="">
        </div>

        <section class="main-content">
            <h2>Ayo mulai dengan mengisi data</h2>
            <p>Isi data Pemberi Kerja TKA dengan benar</p>

            <div class="isi-data">
                <label for="">Nama Pemberi Kerja TKA</label>
                <input type="text" v-model="formData.nama" name="" disabled id=""
                    placeholder="isi nama Pemberi Kerja TKA">
                <label for="">Username</label>
                <input type="text" v-model="formData.username" name="" disabled id="" placeholder="isi username">
                <label for="">NPWP</label>
                <input type="text" v-model="formData.npwp" name="" @input="formatNpwp" id=""
                    placeholder="contoh : 0000.0000.0000.0000">
                <label for="">Nama Penanggung Jawab</label>
                <input type="text" v-model="formData.nama_pemohon" name="" id=""
                    placeholder="isi nama penanggung jawab akun">
                <label for="">Email Pemberi Kerja TKA</label>
                <input type="email" v-model="formData.email" name="" id="" placeholder="isi email Pemberi Kerja TKA">
                <label for="">No Telepon Pemberi Kerja TKA</label>
                <input type="text" v-model="formData.no_hp" name="" id=""
                    placeholder="isi nomor telepon Pemberi Kerja TKA">
                <label for="">Foto Profile</label>
                <input type="file" @change="fotoHandler" accept=".jpg,.jpeg,.png,.webp" name="" id="">

                <button @click="kirim">Simpan data</button>
                <button @click="batal">Batal buat</button>
            </div>
        </section>
    </section>
</template>
<script>
import axios from "axios"
import Swal from "sweetalert2";
import { backend as be } from "@/assets/config/server.js"
import {  setCookie } from "@/assets/config/cookie";
import { useAccountStore } from "@/store/account";
//import { postdata } from "@/utils/userchatcontrol";
import api from "@/services/api";

var sessionToken = null

export default {
    name: "DashboardReport",
    components: {
    },
    data() {
        return {
            show: true,
            formData: {
                nama: "",
                username: "",
                npwp: "",
                pic: "",
                email: "",
                no: "",
                foto: null,

            },
            accountstore: useAccountStore()
        }
    },
    updated() {

    },
    mounted() {
        const infoAkun = this.accountstore //JSON.parse(getCookie("userinfo") || "{}");
        const namaAkun = this.accountstore.perusahaan.nama_perusahaan //getCookie("namaPerusahaan");

        this.formData.username = infoAkun.user
        this.formData.nama = namaAkun
        sessionToken = this.accountstore.accessToken //getCookie("token");

        //console.log(this.accountstore)
        //alert(sessionToken)
    },
    methods: {
        fotoHandler(event) {
            const selectedFile = event.target.files[0];

            if (!selectedFile) {
                return;
            }

            const fileSizeMB = selectedFile.size / (1024 * 1024);

            if (fileSizeMB > 2) {
                Swal.fire({
                    icon: "error",
                    title: "Ukuran File Terlalu Besar",
                    text: "Maksimal ukuran file adalah 2 MB!",
                });

                event.target.value = null;
                this.formData.image = null;

                return;
            }

            this.formData.image = selectedFile;

            // console.log("FILE:", this.formData.image);
            // console.log("Nama:", this.formData.image.name);
            // console.log("Size:", this.formData.image.size);
            // console.log("Type:", this.formData.image.type);
            // console.log(
            //     "Instance File:",
            //     this.formData.image instanceof File
            // );
        },
        formatNpwp() {
            // Hapus semua karakter selain angka
            let digits = this.formData.npwp.replace(/\D/g, "");

            // Batasi maksimal 16 digit
            digits = digits.slice(0, 16);

            if (digits.length === 15) {
                // Format 15 digit → 00.000.000.0.000.000
                this.formData.npwp = digits.replace(
                    /^(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3}).*$/,
                    "$1.$2.$3.$4.$5.$6"
                );
            } else {
                // Format 16 digit → 0000.0000.0000.0000
                this.formData.npwp = digits
                    .replace(/(\d{4})(?=\d)/g, "$1.")
                    .replace(/\.$/, "");
            }
        },
        batal() {
            //const sessionToken = getCookie("token");

            // 1️⃣ Hapus cookie dulu (langsung logout dari sisi client)
            // deleteCookie('userinfo');
            // deleteCookie('token');
            // deleteCookie('namaPerusahaan');
            // deleteCookie('statusPerusahaan');

            // 2️⃣ Langsung arahkan user ke halaman login
            const account = useAccountStore()
            account.clearSession()
            window.location.href = 'https://tka-online.kemnaker.go.id/apl/account/logout'
            //this.$router.push("/");

            // 3️⃣ Panggil logout API di background (tidak menunggu hasil)
            // setTimeout(() => {
            //     axios.post(`${be}/api/logout`, {}, {
            //         headers: {
            //             Accept: "application/json",
            //             Authorization: `Bearer ${sessionToken}`,
            //         },
            //     }).catch(err => console.error("Gagal logout server:", err));
            // }, 300);
        },
        async kirim() {
            const {
                nama,
                username,
                npwp,
                nama_pemohon,
                email,
                no_hp,
                image
            } = this.formData;

            // ==========================================
            // Validasi field
            // ==========================================

            if (
                !nama ||
                !username ||
                !npwp ||
                !nama_pemohon ||
                !email ||
                !no_hp ||
                !image
            ) {
                return Swal.fire({
                    title: "Gagal!",
                    text: "Semua field wajib diisi, termasuk foto profil.",
                    icon: "error",
                });
            }

            // ==========================================
            // Validasi email
            // ==========================================

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(email)) {
                return Swal.fire({
                    title: "Email tidak valid!",
                    text: "Masukkan email dengan format yang benar, misalnya nama@domain.com",
                    icon: "warning",
                });
            }

            // ==========================================
            // Buat FormData
            // ==========================================

            const formData = new FormData();

            formData.append("nama", nama);
            formData.append("username", username);
            formData.append("npwp", npwp);
            formData.append("nama_pemohon", nama_pemohon);
            formData.append("email", email);
            formData.append("no_hp", no_hp);
            formData.append("image", image);

            // ==========================================
            // DEBUG
            // ==========================================

            // console.log("===== FORM DATA =====");

            // for (const [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }

            // ==========================================
            // Kirim
            // ==========================================

            try {

                const response = await api.post(
                    "api/register1",
                    formData
                );

                //console.log("Response:", response);

                if (response.status === 200) {

                    setCookie("statusPerusahaan", true, 12);

                    // let temp = JSON.parse(
                    //     getCookie("userinfo")
                    // );

                    // temp.image = response.data.user.image;

                    // setCookie(
                    //     "userinfo",
                    //     JSON.stringify(temp),
                    //     12
                    // );

                    Swal.fire({
                        title: "Berhasil!",
                        text: "Data Berhasil Tersimpan",
                        icon: "success",
                    }).then(() => {
                        //this.$router.push("/");
                        window.location.reload()
                    });

                }

            } catch (error) {

                console.error("Error register:", error);

                const errors =
                    error.response?.data?.errors;

                let tempString = "";

                if (Array.isArray(errors)) {

                    errors.forEach((el) => {
                        tempString += el.message + ", ";
                    });

                } else if (errors) {

                    tempString = JSON.stringify(errors);

                } else {

                    tempString =
                        error.response?.data?.message ||
                        "Terjadi kesalahan.";

                }

                //console.log(error)

                Swal.fire({
                    title: "Gagal!",
                    text: tempString,
                    icon: "error",
                });
            }
        },
        async getApi(api, parameter = {}) {
            try {
                await axios.get(
                    `${be}/${api}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    },
                    parameter
                );

                //console.log(res)
            } catch (err) {
                console.error(err)
            }
        },
        async postApi(api, datapost = {}, contentType = "multipart/form-data") {
            //console.log(api,sessionToken)
            try {
                const res = await axios.post(
                    `${be}/${api}`,
                    datapost,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": contentType,
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    }
                );

                return res;
            } catch (err) {
                return err;
            }
        }

    }
}
</script>
<style>
h2 {
    font-family: poppins-semi;
}

.dataisian {
    padding: 20px;
    box-sizing: border-box;
    height: 100vh;
    width: 100%;
}

.logo {
    width: max-content;
    height: max-content;

    img {
        width: 50px;
        height: 50px;
        background-color: transparent;
        object-fit: contain;
    }
}

.main-content {
    background-color: none;
    margin-left: auto;
    margin-right: auto;
    width: 400px;
    height: max-content;

    h2,
    p {
        text-align: center;
    }

    p {
        font-family: poppins-reg;
        color: rgb(163, 163, 163);
    }

    .isi-data {
        height: max-content;
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;

        label,
        input {
            display: block;
        }

        label {
            font-size: 11pt;
        }

        input:disabled {
            background-color: #f2f2f2;
        }

        input,
        button {
            margin-bottom: 20px;
            margin-top: 7px;
            font-family: poppins-reg;
            width: 100%;
            background-color: white;
            border: 2px solid #f2f2f2;
            padding: 10px 10px;
            box-sizing: border-box;
            border-radius: 7px;
        }

        button {
            background-color: #1869ff !important;
            color: white;
            border-color: #1869ff;
        }


    }
}
</style>